module.exports = __webpack_public_path__ + "static/media/finacials-green.1a2bfd6d.svg";